const ALLOWED_TAGS = new Set([
  "a",
  "b",
  "blockquote",
  "br",
  "div",
  "em",
  "h1",
  "h2",
  "h3",
  "h4",
  "hr",
  "i",
  "img",
  "li",
  "ol",
  "p",
  "span",
  "strong",
  "u",
  "ul",
]);

const ALLOWED_ATTRS = new Set([
  "alt",
  "class",
  "height",
  "href",
  "rel",
  "src",
  "target",
  "width",
]);

function isSafeUrl(value) {
  const url = String(value || "").trim();
  if (!url) return false;
  if (url.startsWith("/") || url.startsWith("#")) return true;
  return /^(https?:|mailto:|tel:)/i.test(url);
}

export function sanitizeHtml(html) {
  if (!html || typeof document === "undefined") return "";
  const template = document.createElement("template");
  template.innerHTML = String(html);
  const walk = (node) => {
    [...node.childNodes].forEach((child) => {
      if (child.nodeType === Node.COMMENT_NODE) {
        child.remove();
        return;
      }
      if (child.nodeType !== Node.ELEMENT_NODE) return;
      const tag = child.tagName.toLowerCase();
      if (!ALLOWED_TAGS.has(tag)) {
        child.remove();
        return;
      }
      [...child.attributes].forEach((attr) => {
        const name = attr.name.toLowerCase();
        if (!ALLOWED_ATTRS.has(name) || name.startsWith("on")) {
          child.removeAttribute(attr.name);
          return;
        }
        if ((name === "href" || name === "src") && !isSafeUrl(attr.value)) {
          child.removeAttribute(attr.name);
        }
      });
      if (tag === "a") {
        child.setAttribute("rel", "noopener noreferrer");
      }
      walk(child);
    });
  };
  walk(template.content);
  return template.innerHTML;
}
